import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

/**
 * Catches render errors and shows them on screen so we don't get a white screen.
 */
export class ErrorBoundaryFallback extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div
          style={{
            padding: 24,
            fontFamily: 'monospace',
            backgroundColor: '#1a1a1a',
            color: '#ff6b6b',
            minHeight: '100vh',
            overflow: 'auto',
          }}
        >
          <h1 style={{ color: '#fff' }}>Something went wrong</h1>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {this.state.error.toString()}
          </pre>
          {this.state.errorInfo && (
            <details style={{ marginTop: 16 }}>
              <summary style={{ cursor: 'pointer', color: '#888' }}>Component stack</summary>
              <pre style={{ whiteSpace: 'pre-wrap', color: '#888', marginTop: 8 }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
